import { Wording } from '@/types';

export const YOGA_WORDING_SI: Wording = {
  components_header_media_content: 'Vadbe',
  components_header_media_1: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Člani',
  hero_text: 'Ohranite svoje telo gibčno in močno',
  hero_button_text: 'Začnite svojo joga pot',
  components_ressources_section_title: 'VIRI',
  components_ressources_subheader_text: 'Vsi viri, ki jih potrebujete za harmoničen življenjski slog',
  components_ressources_span_text: 'Odkrijte skrivnosti dobrega počutja: Potopite se v zbirko joga položajev, čuječih meditacij in zdravih receptov za ustvarjanje ravnovesja v vseh vidikih svojega življenja.',
  components_ressources_card_1_title: 'Nasveti za jogo',
  components_ressources_card_1_text: 'Praktični nasveti za poglobitev prakse in izpopolnitev poz.',
  components_ressources_card_2_title: 'Dieta',
  components_ressources_card_2_text: 'Pametni nasveti za prehrano za bolj zdravo in močnejšo različico sebe.',
  components_ressources_link: 'Oglejte si videoposnetke',
  components_notes_and_google_title_1: 'Joga vadba',
  components_notes_and_google_title_2: 'Redna rutina',
  components_notes_and_google_title_3: 'Vzdrževanje prehrane',
  components_review_google_text: 'Ocena na Googlu',
  media_content_section_title: 'VADBE',
  media_content_section_subheader_text: 'Naši videoposnetki',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Več videoposnetkov',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članki in novice',
  text2_section_button_more: 'Več člankov',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Nahranite svoje telo in um',
  components_text1_span_text: 'Zdravi recepti za podporo vaši praksi joge in izboljšanje vašega dobrega počutja.',
  components_text1_card_1_title: 'Energični zajtrki',
  components_text1_card_1_text: 'Zbudite se ob živahnih in energijsko polnih obrokih.',
  components_text1_card_3_title: 'Kosila z veliko energije',
  components_text1_card_3_text: 'Odkrijte okusne in priročne recepte za kosilo, zasnovane za vaš aktivni življenjski slog. Od pisanih solat do beljakovinsko bogatih zavitkov, ti recepti vas bodo napolnili z energijo in vam zagotovili osredotočenost.',
  components_text1_card_2_title: 'Večerje za okrevanje',
  components_text1_card_2_text: 'Za zadovoljiv zaključek dneva raziščite različne puste beljakovine, polnozrnata žita in živahno zelenjavo.',
  components_text1_link: 'Oglejte si vse recepte',
  components_footer_text: 'Poiščite ravnovesje, globoko dihajte: Vaša joga, vaše potovanje.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registrska številka',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Pogoji poslovanja',
  components_footer_privacy: 'Pravilnik o zasebnosti',
  button_load_more: 'Naloži več',
  page_media_1_content_hero_text: 'Joga vadbe',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Prehrana',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članki in novice',
  enter_email_title: 'Za nadaljevanje vnesite svoj e-poštni naslov',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Vnesite',
  components_login_success_text: 'Prijava uspešna!',
  components_card_link_media_content: 'Oglejte si zdaj',
  components_card_link_text1_content: 'Ogled recepta',
  components_card_link_text2_content: 'Ogled članka',
  france: 'Francija',
  cyprus: 'Ciper',
};